import { Stack, styled } from '@mui/material';

/**
 * Wrapper for the invoice list with internal scrolling.
 * Used within DTicketPageLayout with scrollable=false.
 */
export const StyledDownloadInvoicesListWrapper = styled(Stack)(({ theme }) => ({
	gap: theme.spacing(1.5),
	flex: 1,
	overflowY: 'auto',
	minHeight: 0,
}));
